import { put, call, all } from 'redux-saga/effects'
import { replace } from 'connected-react-router'
import ClientActions from '../store/clientRedux'

export const getResultsCount = state => state.client.resultsCount

export function* searchClients(api, action) {
    var searchCriteria = action.searchCriteria;
    // yield put(LayoutActions.setPageLoading(true))
    yield put(ClientActions.resetClients())

    // todo: determine if we can remove this now that we have route parameters in place.
    // we may need to keep it in order to check whether or not the user has performed a search before navigating somewhere.
    yield put(ClientActions.setSearchCriteria(searchCriteria))
    
    // VAI-861 Modified Search to allow for the retrieval of returns. Piggybacking onto ClientSagas but should re-factor into SearchSaga

    const upperCriteria = (searchCriteria || '').toUpperCase();
    if (upperCriteria.startsWith('ID-') || upperCriteria.startsWith('VMID-')) {
        yield put(ClientActions.setClients({
            clients: [],
            resultsCount: 0,
            searchCriteria: upperCriteria,
            searchCriteriaType: 'ReturnId'
        }));
    } else {
        var clientResponse = yield call(api.searchClients, searchCriteria);
        
        if (clientResponse.ok && clientResponse.status === 200) {
            yield put(ClientActions.setClients(clientResponse.data));
        }
    }
}

export function* getDiyProductsByAccount(api, action) {

    var purchaseData;

    const [returnsResponse, presalesResponse, oteReturnsResponse] = yield all([
        call(api.getReturnsByAccount, action.accountid),
        call(api.getPresalesByAccount, action.accountid),
        call(api.getOteReturnsByAccount, action.accountid)
    ])

    var totalResponseData = [];

    if (returnsResponse.ok && returnsResponse.status === 200) {
        totalResponseData = returnsResponse.data;
    }

    if (presalesResponse.ok && presalesResponse.status === 200) {
        totalResponseData = totalResponseData.concat(presalesResponse.data);
    }

    if (oteReturnsResponse.ok && oteReturnsResponse.status === 200) {
        totalResponseData = totalResponseData.concat(oteReturnsResponse.data);
    }

    if (totalResponseData !== null) {
        purchaseData = ClientActions.setPurchasedProducts(totalResponseData);
        yield put(purchaseData);
    }
        
}

export function* getAccountHistoryById(api, action) {
    var response = yield call(api.getAccountHistory, action.data);
    if (response.ok  && response.status === 200) {
        yield put(ClientActions.setAccountHistory(response.data))
    }
}

export function* createSearchLog(api, action) {
    yield call(api.createSearchLog, action);
}

export function* getSecurityInfoById(api, action) {
    var response = yield call(api.getSecurityInfo, action.data);
    if (response.ok  && response.status === 200) {
        yield put(ClientActions.setSecurityInfo(response.data))
    }
}

export function* getClientById(api, action) {
    var response = yield call(api.getClient, action.id);
    if (response.ok  && response.status === 200) {
        yield put(ClientActions.setSelectedClient(response.data))
    }
}

export function* searchReturns(api, action) {
    var returnResponse = yield call(api.searchReturns, action);
    const emptyReturnResults = {
        searchcriteria: '',
        searchcriteriatype: '',
        returns: [],
        associatedreturnid: null
    };

    if (returnResponse.ok && returnResponse.status === 200) {
        const returnData = returnResponse.data || emptyReturnResults;
        const returns = returnData.returns || [];
        const firstReturnId = returns.length > 0 ? returns[0].returnid : null;

        yield put(ClientActions.setReturns(returnData));

        if (firstReturnId) {
            yield put(ClientActions.searchAssociatedReturn(firstReturnId, action.taxYear));
        }
        return;
    } else {
        yield put(ClientActions.setReturns(emptyReturnResults));
    }

    var searchCriteria = 'ID-' + action.id + '-' + action.taxYear;
    var returnFailResponse = yield call(api.searchClients, searchCriteria);

    if (returnFailResponse.ok && returnFailResponse.status === 200) {
        yield put(ClientActions.setClients(returnFailResponse.data));
        yield put(replace('/clients/search'));
    }
    yield put(replace('/clients/search'));
}

export function* searchAssociatedReturn(api, action) {
    var returnResponse = yield call(api.searchAssociatedReturn, action);
    if (returnResponse.ok && returnResponse.status === 200) {
        yield put(ClientActions.setAssociatedReturn(returnResponse.data));
    }    
}

export function* getParty(api, action) {
    var returnResponse = yield call(api.getParty, action);
    if (returnResponse.ok && returnResponse.status === 200) {
        yield put(ClientActions.setParty(returnResponse.data));
    }
}



